import React, { useState, useEffect } from "react";
import { Tab, Nav, Container } from "react-bootstrap";
import jsDig from "utils/jsDig";
import enTranslations from '@shopify/polaris/locales/en.json';
import {AppProvider, Page, Card, Button, Badge, List, TextContainer, TextStyle} from '@shopify/polaris';

export default function Team(props) {
  const indexUrl = `/datapulse/shopify/app?shop=${props.shop}`
  const breadcrumbs = [{content: 'DataPulse Bridge by Digital Position', url: indexUrl}];

  return (
    <AppProvider i18n={enTranslations}>
      <Page 
        fullWidth 
        title="Team"
        breadcrumbs={breadcrumbs}
      >
        <Card title="Meet your team" sectioned>
          {props.client_account ? (
            <>
              <TextContainer>
                <b>Account Leads:</b>
                {(props.account_leads && props.account_leads.length > 0) ? (
                  <>
                    <List type="bullet">
                      {props.account_leads.map((user) => {
                        return (
                          <>
                            <List.Item>
                              <b>Name: </b>{`${user.first_name} ${user.last_name}`},
                              <b>   Phone: </b>{(user.phone_number && user.phone_number != "") ? user.phone_number : "Not set"},
                              <b>   Role: </b>{(user.job_title && user.job_title != "") ? user.job_title : "Not set"}
                            </List.Item>
                          </>
                        )
                      })}
                    </List>
                  </>
                ) : (
                  <>
                    <p>After your account is configured, account leads & contact information will appear here.</p>
                  </>
                )}
              </TextContainer>
              <div style={{marginTop: "30px"}}></div>
              <TextContainer>
                <b >Account Supports:</b>
                {(props.account_supports && props.account_supports.length > 0) ? (
                  <>
                    <List type="bullet">
                      {props.account_supports.map((user) => {
                        return (
                          <>
                            <List.Item>
                              <b>Name: </b>{`${user.first_name} ${user.last_name}`},
                              <b>   Phone: </b>{(user.phone_number && user.phone_number != "") ? user.phone_number : "Not set"},
                              <b>   Role: </b>{(user.job_title && user.job_title != "") ? user.job_title : "Not set"}
                            </List.Item>
                          </>
                        )
                      })}
                    </List>
                  </>
                ) : (
                  <>
                    <p>After your account is configured, account supports & contact information will appear here.</p>
                  </>
                )}
              </TextContainer>
            </>
          ) : (
            <>
              <TextContainer>
                <p className="mb-4">Even though you have successfully installed the DataPulse Bridge shopify app, it looks like your store ({props.shop}) hasn't been configured in DataPulse yet. You can see complete data about the Digital Position employees who are assisting your marketing efforts by going to DataPulse, but you may see basic contact information about them on this page once we have finished configuring your account. Reach out to your Digital Position representative to address this issue.</p>
              </TextContainer>
            </>
          )}
        </Card>
      </Page>
    </AppProvider>
  )
}